<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
  >

    <b-card 
      style="border: 1px solid #c9c9c9"
      class="mt-3"
      v-if="interconsulta && !loadingData"
    >
      <h3 class="text-center mb-3">Informacion de la Interconsulta</h3>

      <b-row>
        
        <span class="col-12">
          <b>Paciente:</b> 
          {{ interconsulta.paciente }}
        </span>
        <span class="col-12">
          <b>Doctor:</b>  
          {{ interconsulta.doctor }}
        </span>
        <span class="col-6">
          <b>Establecimiento:</b> 
          {{ establecimientoText }}
        </span>
          
        <span class="col-6">
          <b>Especialidad:</b> 
          {{ especialidadText }}
        </span>
        <span class="col-6">
          <b>Fecha:</b>  
          {{ interconsulta.fechaInterconsulta || 'No asignado' }}
        </span>
        <span class="col-6">
          <b>Tipo servicio:</b> 
          {{ servicioText }}
        </span>

        <span class="col-6">
          <b>Estado:</b> 
          {{ estadoText }}
        </span>

        <span class="col-6">
          <b>Es urgente:</b> 
          {{ interconsulta.esUrgente ? 'Si' : 'No' }}
        </span>

      </b-row>

      <hr>

      <b-row>
        <span class="col-12 mb-2">
          <b>Motivo:</b> 
          {{ interconsulta.motivo || '' }}
        </span>

        <span class="col-12 mb-2">
          <b>Cuadro Clinico:</b> 
          {{ interconsulta.cuadroClinico || '' }}
        </span>

        <span class="col-12 mb-2">
          <b>Resultado de Examenes:</b> 
          {{ interconsulta.resultadoExamenes || '' }}
        </span>

        <span class="col-12 mb-2">
          <b>Plan Terapeutico:</b> 
          {{ interconsulta.planTerapeutico || '' }}
        </span>
      </b-row>
      

      <b-row v-if="interconsulta.diagnosticos">
        <span class="col-12 mb-2">
          <DiagnosticosList 
            v-model="interconsulta.diagnosticos"
            onlyView
            class="my-1"
          />
        </span>
      </b-row>

      <hr>
      <b-row>
        <b-col>
          <h6>Informes:</h6>

          <b-row
            v-if="showInforme007"
            class="mt-1"
          >
            <b-col>
              <span>Formulario 007:</span>

              <b-button
                size="sm"
                class="ml-2"
                @click="onViewFile007(tokenInterconsulta)"
                :disabled="load007"
              >
                <i class="fa-solid fa-file-arrow-down"/>
              </b-button>
            </b-col>
          </b-row>
          
        </b-col>
        
      </b-row>

    </b-card>

    <GeneralLoader v-if="loadingData" :size="'100'" class="my-5"/>

    <ModalViewFile
      v-if="modalFile.fileToView"
      :urlFile="modalFile.fileToView"
      :rutaCompleta=modalFile.isRutaCompleta
      v-model="modalFile.isVisible"
    />

  </b-modal>
</template>

<script>

import { DiagnosticosList, GeneralLoader, ModalViewFile } from '@/shared/components';
import { interconsultaService } from '../../services';
import { interconsultaMapper } from '../../helpers';

export default {
  name: "InterconsultaModalView",

  components: {
    DiagnosticosList,
    GeneralLoader,
    ModalViewFile
  },

  data(){
    return {
      isVisible: false,
      tokenInterconsulta:null,
      interconsulta:{},

      loadingData: false,

      modalFile:{
        fileToView: null,
        isVisible: false,
        isRutaCompleta: false
      },

      load007: false
    }
  },


  created() {
    this.setTokenInterconsulta();
  },


  methods: {
    async onGetDataInterconsulta(tokenInterconsulta){

      this.loadingData = true;

      const data = await interconsultaService.getByToken(tokenInterconsulta);

      if (!data){
        this.$swal("Error", "La interconsulta no existe.", "error")
          .then(
            () => this.$router.push({ name: 'interconsultas' })
          );

        this.loadingData = false;
        return;
      }

      this.isVisible = true;
      this.interconsulta = await interconsultaMapper( data );

      this.loadingData = false;
    },


    setTokenInterconsulta(){
      this.tokenInterconsulta = this.$route.query.view_interconsulta;
      this.interconsulta = {};
    },


    async onViewFile007(tokenInterconsulta) { 
      this.load007 = true;
      const urlTemp = await interconsultaService.getUrlView007(tokenInterconsulta);

      if (!urlTemp) {
        this.load007 = false;
        this.$swal({
          title: 'Error',
          text: "El archivo no existe, comunicar con el adminsitrador sistema",
          icon: 'error',
        });
        return;
      }

      this.modalFile.isRutaCompleta = true;
      this.modalFile.fileToView = urlTemp;
      this.modalFile.isVisible = true;
      this.load007 = false;
    },
  },


  computed:{
    
    establecimientoText(){
      return this.interconsulta.establecimiento?.text || 'No asignado';
    },

    especialidadText(){
      return this.interconsulta.especialidad?.text || 'No asignado';
    },

    estadoText(){
      return this.interconsulta.estado?.text || 'No asignado';
    },

    servicioText(){
      return this.interconsulta.servicio?.text || 'No asignado';
    },

    showInforme007(){
      return this.interconsulta.estado?.value === '1';
    }
  },


  watch: {
    '$route.query.view_interconsulta': {

      handler() {
        this.setTokenInterconsulta();
      },
    },

    tokenInterconsulta:{
      deep: true,
      handler(newValue){
        if(!newValue) return;
        this.onGetDataInterconsulta(newValue);
      }
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.view_interconsulta;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }

  },


  

}
</script>